import React from "react"
import PropTypes from "prop-types"

import "./hello_interstitial.scss"

const HelloInterstitial = ({
  clickAccept,
  clickAcceptTracking,
  clickAcceptUrl,
  clickDeclineTracking,
  ctaTitle,
  declineCopy,
  logoHtml,
  mainBody,
  mainTitle,
  noCreditCardCopy,
  onClickDecline,
}) => {
  const clickAcceptHandler = event => {
    if (clickAccept) {
      event.preventDefault()
      clickAccept()
    }
  }

  return (
    <div styleName="base">
      <div styleName="popup-container" onClick={onClickDecline}>
        <div styleName="popup-card" onClick={e => e.stopPropagation()}>
          <a
            data-track-ifttt-next-event="click"
            data-track-data={JSON.stringify(clickAcceptTracking)}
            href={clickAcceptUrl}
            onClick={clickAcceptHandler}
          >
            <div styleName="sla-img-container">
              <div
                styleName="logo"
                dangerouslySetInnerHTML={{ __html: logoHtml }}
              />
            </div>
          </a>
          <div styleName="right">
            <a
              data-track-ifttt-next-event="click"
              data-track-data={JSON.stringify(clickAcceptTracking)}
              href={clickAcceptUrl}
              onClick={clickAcceptHandler}
            >
              <div styleName="copy">
                <h4>{mainTitle}</h4>
                <p>{mainBody}</p>
                <p>
                  <strong>{noCreditCardCopy}</strong>
                </p>
              </div>
            </a>
            <div styleName="cta">
              <a
                data-track-ifttt-next-event="click"
                data-track-data={JSON.stringify(clickAcceptTracking)}
                href={clickAcceptUrl}
                onClick={clickAcceptHandler}
                styleName="btn"
                className="btn btn-sm"
              >
                {ctaTitle}
              </a>
              <button
                onClick={onClickDecline}
                styleName="btn later"
                data-track-ifttt-next-event="click"
                data-track-data={JSON.stringify(clickDeclineTracking)}
              >
                {declineCopy}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

HelloInterstitial.propTypes = {
  clickAccept: PropTypes.func,
  clickAcceptTracking: PropTypes.object.isRequired,
  clickAcceptUrl: PropTypes.string,
  clickDeclineTracking: PropTypes.object.isRequired,
  ctaTitle: PropTypes.string.isRequired,
  declineCopy: PropTypes.string.isRequired,
  logoHtml: PropTypes.string.isRequired,
  mainBody: PropTypes.string.isRequired,
  mainTitle: PropTypes.string.isRequired,
  noCreditCardCopy: PropTypes.string,
  onClickDecline: PropTypes.func.isRequired,
}

export default HelloInterstitial
